import { render, staticRenderFns } from "./RegisterNew.vue?vue&type=template&id=73aa4be8&scoped=true&"
import script from "./RegisterNew.vue?vue&type=script&lang=js&"
export * from "./RegisterNew.vue?vue&type=script&lang=js&"
import style0 from "./RegisterNew.vue?vue&type=style&index=0&id=73aa4be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa4be8",
  null
  
)

export default component.exports